<template>
  <article class="inquiry-wrapper container" id="inqueryTxtArea">
    <div class="text-wrapper">
      <p>문의하기</p>
      <p>
        B2B 교육에 대한 문의 남겨주시면 최대한 빠른 시간 내에 연락 드리겠습니다.
      </p>
    </div>
    <form action="" class="form-wrapper">
      <div class="input-wrapper">
        <ul>
          <li>
            <label for="company">회사명*</label>
            <div>
              <input type="text" id="company" v-model.trim="add.company" />
            </div>
          </li>
          <li>
            <label for="manager">담당자명*</label>
            <div>
              <input type="text" id="manager" v-model.trim="add.manager" />
            </div>
          </li>
          <li>
            <label for="mobile">연락처*</label>
            <div>
              <input type="tel" id="mobile" v-model.trim="add.mobile1" />
              <p>-</p>
              <input type="tel" v-model.trim="add.mobile2" />
              <p>-</p>
              <input type="tel" v-model.trim="add.mobile3" />
            </div>
          </li>
          <li>
            <label for="email">이메일*</label>
            <div>
              <input type="email" id="email" v-model.trim="add.email" />
            </div>
          </li>
          <li class="funnel">
            <label>유입경로*</label>
            <div>
              <ul>
                <li>
                  <input
                    class="pointer"
                    type="radio"
                    v-model="add.enterPath"
                    id="case1"
                    value="센터원 홈페이지"
                  />
                  <label class="pointer" for="case1">센터원 홈페이지</label>
                </li>
                <li>
                  <input
                    class="pointer"
                    type="radio"
                    v-model="add.enterPath"
                    id="case2"
                    value="캐럿 컨퍼런스 및 설명회 등 모임"
                  />
                  <label class="pointer" for="case2"
                    >캐럿 컨퍼런스 및 설명회 등 모임</label
                  >
                </li>
                <li>
                  <input
                    class="pointer"
                    type="radio"
                    v-model="add.enterPath"
                    id="case3"
                    value="온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브, 블로그 등)"
                  />
                  <label class="pointer" for="case3"
                    >온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브,
                    블로그 등)</label
                  >
                </li>
                <li>
                  <input
                    class="pointer"
                    type="radio"
                    v-model="add.enterPath"
                    id="case4"
                    value="인터넷 검색"
                  />
                  <label class="pointer" for="case4">인터넷 검색</label>
                </li>
                <li>
                  <input
                    class="pointer"
                    type="radio"
                    v-model="add.enterPath"
                    id="case5"
                    value="캐럿글로벌 종합안내서 책자 및 사보 등 자료"
                  />
                  <label class="pointer" for="case5"
                    >캐럿글로벌 종합안내서 책자 및 사보 등 자료</label
                  >
                </li>
                <li>
                  <input
                    class="pointer"
                    type="radio"
                    v-model="add.enterPath"
                    id="case6"
                    value="타사 담당자 및 전임자 등 지인 소개"
                  />
                  <label class="pointer" for="case6"
                    >타사 담당자 및 전임자 등 지인 소개</label
                  >
                </li>
              </ul>
              <div>
                <input
                  class="pointer"
                  type="radio"
                  v-model="add.enterPath"
                  id="case7"
                  value="기타 : 직접 입력"
                />
                <label class="pointer" for="case7">기타</label>
                <input
                  class="etc-input"
                  type="text"
                  v-if="add.enterPath === '기타 : 직접 입력'"
                  v-model="add.enterPathText"
                />
              </div>
            </div>
          </li>
        </ul>
        <ul>
          <li class="textarea-wrapper">
            <label for="contents">문의사항*</label>
            <textarea id="contents" v-model="add.contents"></textarea>
          </li>
          <li class="chk-wrapper">
            <input
              type="checkbox"
              id="privateAgree"
              class="pointer"
              v-model="add.privateAgree"
            />
            <label for="privateAgree">
              <span @click="add.openPrivacy">개인정보 수집 및 이용</span>에
              동의합니다.
            </label>
            <div class="ok">
              <button type="button" @click="add.doSubmit">확인</button>
            </div>
            <div v-if="add.privacyTxtArea" class="privacy-wrapper">
              <div class="title">
                <p>개인정보 수집 및 이용</p>
                <p>
                  <img
                    src="@/assets/img/newGlobal/main/inquiry/close.png"
                    alt="img"
                    @click="closePrivacy"
                  />
                </p>
              </div>
              <div class="content">
                캐럿글로벌은 수집한 개인정보를 다음의 목적을 위해 활용합니다.<br />
                ο 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산
                콘텐츠 제공, 구매 및 요금 결제, 본인인증, 물품배송 또는 청구지
                등 발송<br />
                ο 회원 관리<br />
                회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정
                이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 불만처리
                등 민원처리, 고지사항 전달<br />
                ο 마케팅 및 광고에 활용<br />
                신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달,
                인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도
                파악 또는 회원의 서비스 이용에 대한 통계<br />
                ο 기타<br />
                가입횟수 제한, 분쟁조정을 위한 기록보존, 회원의 각종 합격유무
                확인 및 기타 통계자료 산출<br /><br />

                캐럿글로벌은 온라인 및 모바일 회원가입, 상담, 서비스 신청 등등을
                위해 아래와 같은 개인정보를 수집하고 있습니다.<br /><br />

                가. 수집하는 개인정보 항목<br />
                1) 최초 회원가입 시 회원식별 및 최적화된 서비스 제공을 위해
                아래와 같은 정보를 수집합니다.<br />
                - 필수항목: 이름, 아이디, 비밀번호, 이메일, 휴대전화<br />
                - 선택항목: 영문이름, 주소, 일반전화<br /><br />

                2) 서비스 이용과정이나 사업 처리과정에서 아래와 같은 정보들이
                생성되어 수집될 수 있습니다.<br />
                - 웹사이트 이용 시: 서비스 이용기록, 접속로그, 쿠키, 접속IP정보,
                결제기록<br />
                - 모바일 이용 시: 서비스 이용 기록, 접속 로그,
                기기고유번호(디바이스 아이디 또는 IMEI)<br /><br />

                나. 수집방법<br />
                1) 홈페이지를 통한 회원가입, 서비스 이용 결제, 이벤트 응모,
                전화, 팩스, 고객센터 문의<br />
                2) 생성정보 수집 툴을 통한 수집<br /><br />

                개인정보의 보유 및 이용기간은 다음과 같습니다.<br /><br />

                ο 보유항목: 수집항목과 같습니다.<br />
                ο 보유근거: 이용약관 및 개인정보취급방침<br />
                ο 보유기간: 이용계약에 따른 회원자격이 유지되는 기간동안<br /><br />

                그러나 회원탈퇴 후에도 관계법령의 규정에 의하여 보존할 필요가
                있는 경우 캐럿글로벌은 아래와 같이 일정 기간동안 회원정보를
                보관합니다.<br /><br />

                표시/광고에 관한 기록 : 6개월 (전자상거래등에서의 소비자보호에
                관한 법률)<br />
                계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의
                소비자보호에 관한 법률)<br />
                대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의
                소비자보호에 관한 법률)<br />
                소비자의 불만 또는 분쟁처리에 관한 기록 : 3년
                (전자상거래등에서의 소비자보호에 관한 법률) <br />
                신용정보의 수집/처리 및 이용 등에 관한 기록 : 3년 (신용정보의
                이용 및 보호에 관한 법률) 통신비밀보호법에 따른 통신사실확인자료
                3개월<br /><br />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </form>
  </article>
</template>
<script>
import { onMounted, reactive } from "vue";

export default {
  setup() {
    const add = reactive({
      mtype_list: [],
      enterPath: "",
      enterPathText: "",
      category: "",
      company: "",
      manager: "",
      phone: "",
      email: "",
      zipcode: "",
      addr: "",
      addr_sub: "",
      contents: "",
      privateAgree: "",
      privacyTxtArea: false,
      enterUrl: window.origin, //사이트주소

      openPrivacy() {
        //privacy-wrapper
        if (add.privacyTxtArea) add.privacyTxtArea = false;
        else add.privacyTxtArea = true;
      },

      doSubmit: () => {
        let params = {
          category: "Inbound",
          company: add.company,
          manager: add.manager,
          phone: add.mobile1 + "-" + add.mobile2 + "-" + add.mobile3,
          email: add.email,
          zipcode: add.zipcode,
          addr: add.addr,
          addr_sub: add.addr_sub,
          contents: add.contents,
          enterPath: add.enterPath,
          enterPathText: add.enterPathText,
          enterUrl: window.origin, //사이트주소
        };

        if (add.enterPath === "기타 : 직접 입력") {
          if (add.enterPathText === "") {
            alert("직접입력 내용을 입력해주세요.");
            return;
          }
        }

        if (!add.company) {
          alert("회사명을 입력해주세요.");
          return;
        }

        if (!add.manager) {
          alert("담당자명을 입력해주세요.");
          return;
        }

        if (!add.mobile1 || !add.mobile2 || !add.mobile3) {
          alert("연락처를 입력해주세요.");
          return;
        }

        if (!add.email) {
          alert("이메일을 입력해주세요.");
          return;
        }

        if (!add.enterPath) {
          alert("유입경로를 입력해주세요.");
          return;
        }

        if (!add.contents) {
          alert("문의사항을 입력해주세요.");
          return;
        }

        if (!add.privateAgree) {
          alert("개인정보 수집 및 이용에 동의해주세요");
          return;
        }

        const apiUrl =
          location.href.includes("local") || location.href.includes("stage")
            ? `https://stage.carrotians.net`
            : `https://carrotians.net`;

        axios.post(`${apiUrl}/rest/customermgr/addSMP`, params).then((res) => {
          if (res.data.err == 0) {
            gtag_report_conversion(window.location.href);
            window.gtag("event", "conversion", {
              send_to: "AW-11452452150/CYnaCJ7T0YcZELaa-tQq",
            });
            alert("문의가 접수되었습니다.");
            add.enterPath = "";
            add.enterPathText = "";
            add.company = "";
            add.manager = "";
            add.mobile1 = "";
            add.mobile2 = "";
            add.mobile3 = "";
            add.email = "";
            add.enterPath = "";
            add.contents = "";
            add.privateAgree = "";

            // 스크립트 설치
            let wcs_add = {};
            let _nasa = {};
            wcs_add["wa"] = "s_1f1354ae10d6";
            //페이스북 픽셀
            if (window.fbq)
              window.fbq("track", "Purchase", { value: 0.0, currency: "KRW" });
            // 네이버 검색광고 스크립트 적용
            if (window.wcs) {
              //  전환페이지 설정
              _nasa["cnv"] = wcs.cnv("1", "10");
              //  공통 스크립트 적용
              wcs.inflow(window.location.href);
              window.wcs_do(_nasa);
            }
          } else {
            if (res.data.err_msg) alert(res.data.err_msg);
          }
        });
      },
    });

    const gtag_report_conversion = (url) => {
      var callback = function () {
        if (typeof url != "undefined") {
          window.location = url;
        }
      };
      window.gtag("event", "conversion", {
        send_to: "AW-11452452150/CYnaCJ7T0YcZELaa-tQq",
        event_callback: callback,
      });
      return false;
    };
    return { add };
  },
  methods: {
    closePrivacy() {
      const privacyWrapper = document.querySelector(".privacy-wrapper");
      privacyWrapper.style.display = "none";
    },
  },
};
</script>
<style lang="scss" scoped>
.inquiry-wrapper {
  padding: 0 18px 70px 18px;

  .text-wrapper {
    color: #232323;

    p:nth-child(1) {
      font-size: 33px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    p:nth-child(2) {
      font-size: 18px;
      margin-bottom: 15px;
    }
  }

  .form-wrapper {
    .input-wrapper {
      display: flex;
      flex-direction: column;
      gap: 30px 0;

      label {
        flex: none;
        width: 100px;
        color: #232323;
      }

      input[type="text"],
      input[type="email"] {
        flex-grow: 1;
        width: 100%;
        border: 1px solid #dadada;
        padding: 10px;
      }

      input[type="tel"] {
        flex-grow: 1;
        width: 20%;
        border: 1px solid #dadada;
        padding: 10px;
      }

      textarea {
        flex-grow: 1;
        border: 1px solid #dadada;
        resize: none;
      }

      > ul {
        > li {
          display: flex;
          align-items: center;
          margin-bottom: 14px;

          &:last-child {
            margin-bottom: 0;
          }

          div {
            flex-grow: 1;
            display: flex;
            align-items: center;
          }

          &.textarea-wrapper {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px 0;

            textarea {
              width: 100%;
              height: 286px;
            }
          }

          &.chk-wrapper {
            position: relative;
            gap: 0 5px;

            label {
              width: auto;

              span {
                text-decoration: underline;
                cursor: pointer;
              }
            }

            .privacy-wrapper {
              display: block;
              position: absolute;
              top: 25px;
              left: 0;
              width: 100%;
              color: #232323;
              z-index: 1;

              div {
                padding: 5px 10px;
              }

              .title {
                justify-content: space-between;
                font-size: 12px;
                background-color: #e4e4e4;

                img {
                  cursor: pointer;
                }
              }

              .content {
                display: block;
                font-size: 11px;
                height: 150px;
                overflow-y: scroll;
                background-color: #ffffff;
              }
            }
          }

          &.funnel {
            align-items: flex-start;

            > div {
              flex-direction: column;
              align-items: flex-start;
              gap: 10px 0;

              label {
                flex: auto;
                width: auto;
              }

              > ul {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;

                > li {
                  display: flex;
                  align-items: center;
                  gap: 0 5px;
                }
              }

              > div {
                gap: 0 5px;

                .etc-input {
                  padding: 0;
                }
              }
            }
          }
        }
      }
    }

    .ok {
      display: flex;
      justify-content: flex-end;

      button {
        font-size: 16px;
        color: #ff6c00;
        cursor: pointer;
      }
    }
  }
}

@media screen and (min-width: 1350px) {
  .inquiry-wrapper {
    padding: 0 0 150px 0;

    .text-wrapper {
      p:nth-child(1) {
        font-size: 50px;
      }

      p:nth-child(2) {
        font-size: 20px;
      }
    }

    .form-wrapper {
      .input-wrapper {
        flex-direction: row;
        gap: 0 30px;

        > ul {
          width: 50%;
        }
      }
    }
  }
}
</style>
